import React, { PropsWithChildren } from 'react';
import { Row } from 'react-styled-flexboxgrid';

import SelfcareBanner from '@savgroup-front-common/core/molecules/SelfcareBanner';
import { useStepOrchestratorContext } from '@savgroup-front-common/core/molecules/StepsOrchestrator';

import { CreateClaimValues } from '@/types';
import STEP_CONFIG from '@/view/app/Routes/StepConfig';

import StepFooter from './StepFooter/StepFooter';
import StepHeader from './StepHeader/StepHeader';
import { useStepLayoutBannerUrl } from './StepLayout.hooks';
import {
  $BannerWrapper,
  $ColContainer,
  $LayoutGrid,
  $StepContainer,
} from './StepLayout.styles';

interface StepLayoutProps {
  values: CreateClaimValues;
  noConfirmButton?: boolean;
  isDisabled: boolean;
  isLoading?: boolean;
  stepName: STEP_CONFIG;
}

const StepLayout: React.FC<PropsWithChildren<StepLayoutProps>> = ({
  values,
  noConfirmButton = false,
  isDisabled,
  isLoading = false,
  stepName,
  children,
}) => {
  const bannerUrl = useStepLayoutBannerUrl();
  const { isFirstStep, previousStep } = useStepOrchestratorContext();

  const hasBannerUrl = !!bannerUrl;

  const handlePreviousStep = () => previousStep({ values });

  return (
    <>
      {hasBannerUrl && (
        <$BannerWrapper>
          <SelfcareBanner bannerUrl={bannerUrl} />
        </$BannerWrapper>
      )}
      <$LayoutGrid>
        <Row center="xs">
          <$ColContainer xs={12} sm={12}>
            {stepName && (
              <StepHeader stepName={stepName} sellerName={values.sellerName} />
            )}
            <$StepContainer>{children}</$StepContainer>
            <StepFooter
              isFirstStep={isFirstStep}
              isDisabled={isDisabled}
              isLoading={isLoading}
              handlePreviousStep={handlePreviousStep}
              noConfirmButton={noConfirmButton}
            />
          </$ColContainer>
        </Row>
      </$LayoutGrid>
    </>
  );
};

export default StepLayout;
